import styled from '@emotion/styled'
import { calcRem } from 'component-library/__styling/style-functions'
import { colors } from 'component-library/__styling/settings'
import { sevennews, perthnow, thewest } from 'component-library/__styling/themes'
import { themedValue } from 'component-library/__styling/themed-value'
import { withClass } from 'common/emotion'
import { conditionalStyles } from 'component-library/__styling/conditional-styles'

export const styledCardTimestampTextLabel = 'CardTimestamp-Text'

export const StyledTimestamp = withClass(styledCardTimestampTextLabel)(
    styled('time')(
        {
            display: 'block',
            fontWeight: 700,
        },
        ({ theme }) => ({
            fontSize: themedValue(theme, { perthnow: calcRem(14), fallback: calcRem(12) }),
            fontWeight: themedValue(theme, { perthnow: 600, fallback: 700 }),
            background: themedValue(theme, {
                perthnow: colors.perthnow.greyBasalt,
                fallback: colors.white,
            }),
            fontFamily: themedValue(theme, {
                perthnow: perthnow.fonts.sansSerif,
                thewest: thewest.fonts.sansSerif,
                sevennews: sevennews.fonts.sansSerifCond,
            }),
            color: themedValue(theme, {
                perthnow: colors.white,
                thewest: section => section.primaryColor,
                sevennews: resolved => resolved.cards.timestamp.primaryColor,
            }),
            // Carried over from existing list card implementation
            ...conditionalStyles(theme.kind === 'perthnow', {
                flex: '0 0 auto',
                display: 'block',
                padding: calcRem(22, 0),
                alignSelf: 'center',
                textAlign: 'center',
                width: calcRem(68),
                lineHeight: 1,
            }),
        })
    )
)
